import { css, jsx } from '@emotion/react';
import { Colors, Icon, Img, Link, Typography, } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../../utils/avroEvents';
import { ArrowLinkIcon } from '../../ArrowLinkIcon';
const Styles = {
    root: css({
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
        fontWeight: 'initial',
        minHeight: 373,
    }),
    heading: css({
        font: `var(--zds-section-header, 600 24px/36px ${Typography.pageHeader1.fontFamily})`,
        display: 'flex',
        flexDirection: 'column',
        color: 'var(--zds-text-stronger, #201515)',
        fontSize: '30px',
        lineHeight: '24px',
        letterSpacing: '1px',
    }),
    subheading: css({
        font: `var(--zds-small-print-1, 400 13px/20px ${Typography.base.fontFamily})`,
        color: 'var(--zds-gray-warm-9, #413735)',
        display: 'block',
        marginTop: 8,
    }),
    groupsContainer: css({
        display: 'flex',
        gap: '50px',
    }),
    groupHeading: css({
        font: `var(--zds-section-header, 600 24px/36px ${Typography.pageHeader1.fontFamily})`,
        color: 'var(--zds-gray-warm-5: #B5B2AA)',
        fontSize: '14px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        marginBottom: '10px',
    }),
    linkList: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    linkContainer: css({
        textDecoration: 'none',
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        '&:hover [data-tag="link-heading"]': {
            color: 'var(--zds-brand-orange, #FF4F00)',
            textDecoration: 'none',
        },
        '&:hover [data-tag="link-description"]': {
            textDecoration: 'underline',
        },
        '&:hover [data-tag="arrow-icon-wrapper"]': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: `1px solid var(--zds-ui-primary-strongest, #503EBD)`,
        },
    }),
    iconContainer: (background) => css(Object.assign({ display: 'flex', justifyContent: 'center', alignItems: 'center' }, (background && {
        width: 38,
        height: 38,
        borderRadius: '9px',
        backgroundColor: Colors[background],
    }))),
    linkHeading: css({
        font: `var(--zds-body-2, 500 14px/24px ${Typography.base.fontFamily})`,
        color: 'var(--zds-text-stronger, #201515)',
    }),
    linkDescription: css({
        font: `var(--zds-small-print-1, 400 13px/20px ${Typography.base.fontFamily})`,
        lineHeight: '20px',
        color: 'var(--zds-gray-warm-9, #413735)',
    }),
};
export const MegaMenuProductLeftV2 = ({ heading, onCloseMenu, subheading, submenu, parent, }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const emitEvent = (link, eventType) => {
        var _a;
        emitUserInteractionEvent({
            event_action: eventType,
            interaction_name: `universal_nav_submenu_link_${eventType}`,
            option_selected: link.text,
            interaction_raw_text: link.text,
            destination_href: (_a = link.href) !== null && _a !== void 0 ? _a : '',
            custom_tracking_fields: { parent },
        });
    };
    const handleLinkClick = (link) => {
        onCloseMenu === null || onCloseMenu === void 0 ? void 0 : onCloseMenu();
        emitEvent(link, 'click');
    };
    const handleLinkHover = (link) => {
        emitEvent(link, 'hover');
    };
    return (jsx("div", { css: Styles.root, "data-zds": true },
        (heading || subheading) && (jsx("header", { "data-zds": true },
            heading && jsx("span", { css: Styles.heading }, heading),
            subheading && (jsx("span", { css: Styles.subheading, "data-zds": true }, subheading)))),
        jsx("div", { css: Styles.groupsContainer, "data-zds": true }, submenu.map((group) => {
            var _a;
            return (jsx("div", { key: group.text, "data-zds": true },
                jsx("span", { css: Styles.groupHeading }, group.text),
                jsx("ul", { css: Styles.linkList, "data-zds": true }, (_a = group.submenu) === null || _a === void 0 ? void 0 : _a.map((link) => (jsx("li", { key: link.text, "data-zds": true },
                    jsx(Link, { color: null, css: Styles.linkContainer, href: getFullyQualifiedURL(link.href), target: link.target, onClick: () => handleLinkClick(link), onMouseEnter: () => handleLinkHover(link) },
                        link.icon ? (jsx("div", { css: Styles.iconContainer(link.iconBackground), "data-zds": true },
                            jsx(Icon, { color: link.iconColor, name: link.icon, size: 19 }))) : (link.serviceIcon && (jsx(Img, { src: link.serviceIcon.src, alt: `${link.serviceIcon.name} logo`, width: 19, height: 19, objectFit: "contain", borderRadius: 0 }))),
                        jsx("div", { css: {
                                display: 'flex',
                                flexDirection: 'column',
                            }, "data-zds": true },
                            jsx("span", { css: Styles.linkHeading, "data-tag": "link-heading", "data-zds": true }, link.text),
                            link.description && (jsx("span", { css: Styles.linkDescription, "data-tag": "link-description", "data-zds": true },
                                link.description,
                                jsx(ArrowLinkIcon, null)))))))))));
        }))));
};
//# sourceMappingURL=MegaMenuProductLeftV2.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
